<template>
  <div>
    <div class="c-header">
      <div class="user">
        <img :src="user.avatar" />
        <div class="user-info">
          <h3>{{ user.name }}</h3>
          <p>
            {{ user.sex }}士 <span>|</span> {{ user.age }}岁 <span>|</span>
            {{ user.workYear }}年工作经验
          </p>
        </div>
      </div>
      <ul class="c-data-cont">
        <li @click="applicationRecord">
          <p>{{ user.sendResumeCnt }}</p>
          <span>申请记录</span>
        </li>
        <li @click="collectionJobs">
          <p>{{ user.collectionPositionCnt }}</p>
          <span>收藏职位</span>
        </li>
        <li @click="collectionCompanies">
          <p>{{ user.starEntCnt }}</p>
          <span>关注企业</span>
        </li>
      </ul>
    </div>
    <div class="white-cont">
      <div class="white-header">
        <h2>简历中心 <small>完善的简历有助于智能匹配您的工作</small></h2>
        <van-button
          type="primary"
          size="mini"
          color="linear-gradient(to right top, #F69B58,#F87342)"
          round
          @click="myResume"
          >完善简历</van-button
        >
      </div>
      <ul class="cell-list">
        <li class="cell-item" @click="resumeStatus">
          <div class="cell-left">
            <van-icon class="text-org" name="jianli"></van-icon>
            <span>简历状态</span>
          </div>
          <div class="cell-right" v-if="user.id">
            <div
              class="right-text"
              style="margin-right: 10px;"
              v-text="checked ? '开启' : '关闭'"
            ></div>
            <div class="right-inner">
              <van-switch :value="checked" />
            </div>
          </div>
        </li>
        <li class="cell-item">
          <div class="cell-left">
            <van-icon class="text-green" name="shuaxin"></van-icon>
            <span>刷新简历</span>
          </div>
          <div class="cell-right">
            <div class="right-text">
              刷新获得更多曝光度
            </div>
            <div class="right-inner">
              <van-button plain type="info" round size="mini" @click="refresh"
                >刷新</van-button
              >
            </div>
          </div>
        </li>
      </ul>
    </div>
    <van-loading v-if="loading" />
    <div class="white-cont">
      <div class="white-header" @click="recommendResume">
        <h2>简历推荐 <small>一键管理推荐简历至匹配职位</small></h2>
        <div class="header-right">
          <span class="num">{{ user.sysSendResumeCnt }}</span>
          <div>
            待确认 <span>{{ user.sysSendResumeWaitingCnt }}</span>
          </div>
        </div>
      </div>
      <ul class="cell-list">
        <li class="cell-item" @click="recommendedSetting">
          <div class="cell-left">
            <van-icon class="text-blue" name="tuijian"></van-icon>
            <span>简历推荐设置</span>
          </div>
          <div class="cell-right flex-right">
            <div class="right-text" v-text="sysSendSetting"></div>
            <div class="right-inner">
              <van-icon name="gengduo"></van-icon>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <ul class="cell-list" style="margin:26px 32px 26px 26px">
      <li class="cell-item" @click="privacSetting">
        <div class="cell-left">
          <van-icon class="text-purple" name="yanjing"></van-icon>
          <span>隐私设置</span>
        </div>
        <div class="cell-right flex-right">
          <div class="right-text">
            不想被这些企业查看
          </div>
          <div class="right-inner">
            <van-icon name="gengduo"></van-icon>
          </div>
        </div>
      </li>
    </ul>
    <div class="contact-uc">
      <van-icon name="dianhua"></van-icon>
      <div class="contact-info">
        <div class="info-top">
          <h3>监督电话</h3>
          <span>021-59984037</span>
        </div>
        <div class="c-time">上班时间：周一至周五09:00-16:30（节假日除外）</div>
      </div>
    </div>
    <navBar ref="navbarObj"></navBar>
  </div>
</template>

<script>
import navBar from "../components/navbar";

export default {
  name: "index",
  components: {
    navBar
  },
  data() {
    return {
      checked: false,
      user: {},
      loading: false
    };
  },
  watch: {
    checked(val) {
      this.checked = val;
    }
  },
  computed: {
    sysSendSetting() {
      return this.user.sysSendSetting === "否"
        ? "不允许系统自动推荐"
        : "允许系统自动推荐";
    }
  },
  methods: {
    refresh() {
      this.loading = true;
      this.module.api.refreshResume({
        params: {},
        success: res => {
          this.loading = false;
        },
        error: () => {
          this.toast("一天只能刷新一次");
          this.loading = false;
        }
      });
    },
    onload() {
      this.module.api.memberInfo({
        params: {},
        success: res => {
          this.user = res;
          this.checked = res.open == "是" ? true : false;
        }
      });
    },
    myResume() {
      this.$router.push({ name: "myResume" });
    },
    recommendResume() {
      this.$router.push({ name: "recommendResume" });
    },
    applicationRecord() {
      this.$router.push({ name: "applicationRecord" });
    },
    collectionJobs() {
      this.$router.push({ name: "collectionJobs" });
    },
    collectionCompanies() {
      this.$router.push({ name: "collectionCompanies" });
    },
    recommendedSetting() {
      //简历推荐
      this.$router.push({ name: "recommendedSetting" });
    },
    privacSetting() {
      //隐私设置
      this.$router.push({ name: "privacSetting" });
    },
    resumeStatus() {
      //简历状态
      this.$router.push({ name: "resumeStatus" });
    }
  },
  mounted() {
    this.$refs.navbarObj.isMyPage = true;
    this.onload();
  }
};
</script>

<style lang="less" scoped>
.c-header {
  margin-bottom: -90px;
  .user-info:after {
    display: none;
  }
}
/deep/.van-loading {
  position: absolute;
  left: 50%;
}
.van-button--primary {
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 0;
  font-size: 12px;
  .van-button__text {
    font-size: 12px;
  }
}
.user {
  img {
    object-fit: cover;
  }
}
.flex-right {
  .right-text {
    margin-right: -8px;
  }
}
</style>
